<template src="./userNew.html">

</template>

<script>
import { get_userNew } from "@/api/api.admin.js";

import AttivaNuovoUtente from "@/components/dialog/AttivaNuovoUtente";

export default {
  components: {
    AttivaNuovoUtente
  },

  data: () => ({
    dati: [],

    headers: [
      { align: "center", value: "" },
      { text: "Utente", align: "left", value: "Utente" },
      { text: "RagSociale", align: "left", value: "RagSociale" },
      { text: "P.iva", align: "left", value: "Piva" },
      { text: "EMail", align: "left", value: "EMail" },
      {
        text: "DataRegistrazione",
        align: "left",
        value: "DataRegistrazione"
      },
      { align: "center", value: "" }
    ],

    search: "",
    pagination: {
      rowsPerPage: 500
    },
    page: 1,
    pageCount: 0,
    itemsPerPage: 100,

    dialog: false,
    idUtente: 0,

    editedItem: {
      IDRegistrazione: 0,
      Utente: "",
      Password: "",
      RagSociale: "",
      Piva: "",
      DataRegistrazione: "",
      EMail: ""
    },

    filtro: ["Da confermare", "Confermati"],
    filtroSelez: "Da confermare"
  }),

  methods: {
    caricaDati: function() {
      // Reset
      this.dati = [];

      get_userNew("lista/" + this.filtroSelez)
        .then(res => {
          this.dati = res.data;
        })
        .catch(err => {
          console.log("usernew.vue " + err);
        });
    },

    editItem(item) {
      this.idUtente = item.IdUtente;

      this.dialog = true;
    },

    close() {
      this.dialog = false;
    }
  },

  mounted() {
    this.caricaDati();
  }
};
</script>

